<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`出车费用汇总表-费用明细`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceExpenseSummary",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carall',
      getListUrl: 'driverec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/expenseSummary" },
        { name: "出车费用汇总表", path: "/finance/expenseSummary" },
        { name: "费用明细" },
      ],
      searchDateOptions: [
        { ...this.ctrls.XieHuoRiQi, },
        { ...this.ctrls.ZhuangHuoRiQi, },

      ],
      formCtrl: [
        {
          label: "加油方式",
          keyName: "gsid",
          placeholder: "请选择加油方式",
          type: "select",
          options: [],
        },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 130 },
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "infreight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 110 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ orderid }) => {
            this.$router.push(
              `/finance/expenseSummaryFee?id=${orderid}&mode=edit`
            );
          },
        },
      ],
      baseParams: ['license', 'month'],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      if (['gsid', 'fleet', 'month'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    setOptions({ gasstation, dayauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'gsid') {
          this.setCtrlOption(v, gasstation, 'gasname')
        }
      })
      const arr = []
      dayauth.map(v => {
        arr.push({
          keyName: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
          width: '100px',
        })
      })
      this.cols.push(...arr)
      this.cols.push(
        { keyName: "doil", label: "现金加油", align: 'right', className: 'pr30', minwidth: 110 },
        { keyName: "moneydoil", label: "油卡加油", align: 'right', className: 'pr30', minwidth: 110 },
        { keyName: "gsid", label: "加油方式", minwidth: 120 },
        { keyName: "total", label: "费用合计", align: 'right', className: 'pr30', minwidth: 110 }
      )
      this.getTotalProperty = [
        'infreight',
        ...arr.map(v => v.keyName),
        'doil', 'moneydoil', 'total',
      ]
      this.doLayout()
      this.$forceUpdate()
      // console.log({ ...this.formInline })
    },
  },
  created() {
    const { user_group_id } = this.user
    if (user_group_id !== 1) {
      this.btns[0] = {
        ...this.viewBtn,
        cb: ({ orderid }) => {
          this.$router.push(
            `/finance/expenseSummaryFee?id=${orderid}&mode=view`
          );
        },
      }
    }
  },
  mounted() {
    this.getOptions()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
